import instance from "../utils/api_instance.util";

const buildQueryString = (params = {}) => {
    const queryParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
            queryParams.append(key, value);
        }
    });

    const queryString = queryParams.toString();
    return queryString ? `?${queryString}` : "";
};

export const fetchAnalyticsOverviewAPI = async (params = {}) => {
    try {
        const { data } = await instance.get(
            `/api/v1/admin/analytics/overview${buildQueryString(params)}`
        );
        return data;
    } catch (err) {
        throw err;
    }
};

export const fetchAcquisitionAnalyticsAPI = async (params = {}) => {
    try {
        const { data } = await instance.get(
            `/api/v1/admin/analytics/acquisition${buildQueryString(params)}`
        );
        return data;
    } catch (err) {
        throw err;
    }
};

export const fetchAccountStatusAnalyticsAPI = async (params = {}) => {
    try {
        const { data } = await instance.get(
            `/api/v1/admin/analytics/account-status${buildQueryString(params)}`
        );
        return data;
    } catch (err) {
        throw err;
    }
};

export const fetchActivityAnalyticsAPI = async (params = {}) => {
    try {
        const { data } = await instance.get(
            `/api/v1/admin/analytics/activity${buildQueryString(params)}`
        );
        return data;
    } catch (err) {
        throw err;
    }
};
